import template from "./email.html";

const EmailComponent = {
  bindings: {},
  template: template,
  controller: class EmailController {
    /* @ngInject */
    constructor($rootScope, $scope) {
      this.$rootScope = $rootScope;
      this.$scope = $scope;
    }

    $onInit() {
      this.email = this.$rootScope.user.email;

      this.$scope.$on("refreshUser", () => {
        this.email = this.$rootScope.user.email;
      });
    }
  },
};

export default EmailComponent;
